import React from 'react';
import './Content.scss';
import classNames from 'classnames';

export default function Content({ children, className }) {
  return (
    <div className="content-wrapper flex-fill">
      <div className={classNames('background', className)} />
      <div className={classNames('container', className)}>{children}</div>
    </div>
  );
}
